<template>
  <div  v-cloak class="featured">

        <div v-cloak class="row results-row">
          <div class=" col-md-12 col-xs-12">
          <h3 class="title-text text-center"> Recent Opportunities </h3>
          </div>
            <div  v-for="pos of reverse" class="col-md-offset-2 col-md-8 col-xs-10 col-xs-offset-1">
            <!-- <div  v-for="pos of positions.reverse().slice(0,6)" class="col-md-offset-2 col-md-8 col-xs-12"> -->

              <md-card flex md-with-hover md-elevation="15" class="md-primary">
                  <md-card-header>
                    <div class="md-title">Work with {{pos.Organisation}}</div>
                    <div class="md-subhead" style="font-weight:bold;">
                      Commitment: {{pos.Commitment}}<br>
                      Work in {{pos.City}} <br>
                      Category: {{pos.Category}}
                                        </div>
                    <div>
                    </div>
                  </md-card-header>

                  <md-card-expand>

                    <md-card-actions>
                      <md-button v-bind:href="pos.Form" target="_blank" class="theme">Apply</md-button>
                      <md-button md-expand-trigger class="theme">
                        More Info
                      </md-button>
                      <span style="flex: 1"></span>

                    </md-card-actions>

                    <md-card-content> 
                      {{pos.Description}}
                    </md-card-content>
                  </md-card-expand>
            </md-card>
            </div>
          </div>
      </div>


</template>

<script>

import Vue from 'vue'

//Imports db constant from src/components/firebase.js
import {db} from './firebase'

//Imports Material CSS
import VueMaterial from 'vue-material'
import 'vue-material/dist/vue-material.css'

// let opportunityRef = db.ref('Mumbai')
//   let pos = []
// opportunityRef.on('value', function(snapshot) {

//   pos.push(snapshot.val())
// });

// console.log(pos)



Vue.use(VueMaterial)


export default {
  name: 'featured',

  //defines empty thing really important
  data: () => ({
    positions: [],
    recent_positions: []
  }),

  firebase: {
    positions: {
      source: db.ref('Mumbai'),
      // Optional, allows you to handle any errors.
      cancelCallback(err) {
        console.error(err);
      }
    },
  },
  computed: {
    reverse: function() {
        return this.positions.reverse().slice(0,6);
    }
}

};
</script>

<style scoped>

.featured{
  font-family: 'Lato', sans-serif;
}
[v-cloak] {
  display: none;
}

h3{
  font-size:4.5em;
}

.container {
  height: 100%;

}


.title-text{
  /* margin-top:15%; */
  margin-bottom:5%;
  font-family: 'Alegreya Sans SC', sans-serif;
  color: Black;
  text-align: center;
  font-weight: lighter;
}

/* Responsive text */
@media only screen and (max-width: 600px) {
  h3{
      font-size:2.0em;
  }
}

.results-row{
  margin-top:0%;
  text-align: center;
}

/* For the Featured Cards*/
.md-card{
  /*background-image: url('https://static.pexels.com/photos/497848/pexels-photo-497848.jpeg');*/
  margin-top:0.5%;
  margin-bottom: 1%;
  background-color: white;
  /*background-position: center center;*/
  color: #e63946;
  text-align: left;
  min-height: 200px;
  padding-bottom:2px;
}


.md-card-actions{
  background-color: white;
  margin-bottom: 0px;
  color: black;
  padding:30px;
  padding-bottom: 0px;
  text-align: left;
}
.md-card-content{
  background-color: white;
  /* background-color: #427aa1; */
  color: #457b9d;
  font-size: 20px;
  padding:20px;
}
.md-card-expand p{
  font-size: 1em;
}
.md-theme-default.md-card .md-card-expand .md-card-actions {
    background-color: white;
    margin-top:0px;
    color: #05668d;
}
.md-theme-default.md-card.md-primary {
  background-color: white;
}
.md-chip{
  color: white;
  background-color: #457b9d;
  margin-top:3%;
  margin: 0.5%;
  text-transform: uppercase;
}

.theme{
  background-color:transparent;
  color : black;
  border:1px solid #a8dadc;
  width:30%;
  padding:1px;
}
.md-title, .md-subhead{
  color: black;
}
.md-card .md-card-expand.md-active [md-expand-trigger] {
  transform: none;
}
.md-card .md-card-expand [md-expand-trigger] {
  transition: none;
}
.md-card .md-card-expand .md-card-content{
  transfrom: none;
  transition: none;
}
</style>



// WEBPACK FOOTER //
// Featured.vue?5ff2f5ad